<template>
	<div class="firmware-page">
		<Card :title="$tt('固件上传')" class="upload-card">
			<Form
				ref="formRef"
				:model="form"
				:rules="formRules"
				class="compact-form"
				label-position="left"
				:label-width="105"
			>
				<Row :gutter="12">
					<Col :span="8">
						<FormItem :label="$tt('FTP配置')" prop="FtpId">
							<Select
								v-model="form.FtpId"
								:placeholder="$tt('请选择FTP配置')"
								@on-change="handleFtpChange"
								style="width:100%"
							>
								<Option
									v-for="item in ftpOptions"
									:key="item.Id"
									:label="item.Name"
									:value="item.Id"
								/>
							</Select>
						</FormItem>
					</Col>
					<Col :span="8">
						<FormItem :label="$tt('固件版本号')" prop="FileVersion">
							<Input v-model="form.FileVersion" placeholder="1.2.3" />
						</FormItem>
					</Col>
					<Col :span="8">
						<FormItem :label="$tt('固件文件')" prop="FirmwareFile">
							<Upload
								ref="uploadRef"
								action=""
								v-model="form.FirmwareFile"
								:show-upload-list="false"
								multiple
								:before-upload="beforeUpload"
							>
								<Button icon="ios-cloud-upload-outline">{{$tt('选择文件')}}</Button>
								<span v-if="form.FirmwareFile !== null">{{ form.FirmwareFile.name }}</span>
							</Upload>
						</FormItem>
					</Col>
				</Row>

				<!-- FTP 详情：独立展示区，脱离 Form 校验，避免误报错误 -->
				<div v-if="curFtpInfo" class="ftp-info-block">
					<Row :gutter="12">
						<Col :span="5">
							<div class="ftp-field">
								<span class="ftp-label">IP</span>
								<Input :value="curFtpInfo.Ip" disabled />
							</div>
						</Col>
						<Col :span="4">
							<div class="ftp-field">
								<span class="ftp-label">{{$tt('端口')}}</span>
								<Input :value="curFtpInfo.Port" disabled />
							</div>
						</Col>
						<Col :span="6">
							<div class="ftp-field">
								<span class="ftp-label">{{$tt('路径')}}</span>
								<Input :value="curFtpInfo.Path" disabled />
							</div>
						</Col>
						<Col :span="5">
							<div class="ftp-field">
								<span class="ftp-label">{{$tt('用户名')}}</span>
								<Input :value="curFtpInfo.UserName" disabled />
							</div>
						</Col>
						<Col :span="4">
							<div class="ftp-field">
								<span class="ftp-label">{{$tt('密码')}}</span>
								<Input :value="curFtpInfo.UserPwd" type="password" disabled />
							</div>
						</Col>
					</Row>
				</div>

				<Row :gutter="12">
					<Col :span="8">
						<FormItem :label="$tt('版本分类')" prop="FirmwireType">
							<Select
								v-model="form.FirmwireType"
								:placeholder="$tt('版本分类(通用版本/定制版本)')"
								style="width:100%"
							>
								<Option :value="0" :label="$tt('内部测试')" />
								<Option :value="1" :label="$tt('通用版本')" />
								<Option :value="2" :label="$tt('定制版本')" />
							</Select>
						</FormItem>
					</Col>
					<Col :span="8">
						<FormItem :label="$tt('适用客户')" prop="Operators" :required="form.FirmwireType === 2">
							<Select
								v-model="form.Operators"
								filterable
								multiple
								:placeholder="$tt('可多选适用客户')"
								style="width:100%"
							>
								<Option
									v-for="item in customerOptions"
									:key="item.Id"
									:label="item.Name"
									:value="item.Id"
								/>
							</Select>
						</FormItem>
					</Col>
					<Col :span="8">
						<FormItem :label="$tt('适用设备型号')" prop="ModelIds">
							<Select
								v-model="form.ModelIds"
								filterable
								multiple
								:placeholder="$tt('请选择适用设备型号（必填）')"
								style="width:100%"
							>
								<Option
									v-for="item in EquipmentModelDefine"
									:key="item.ModelId"
									:label="item.ModelDesc"
									:value="item.ModelId"
								/>
							</Select>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="12">
					<Col :span="8">
						<FormItem :label="$tt('备注')" prop="Remark">
							<Input v-model="form.Remark" placeholder="" />
						</FormItem>
					</Col>
				</Row>

				<FormItem class="form-btn-row">
					<Button type="primary" :loading="submitLoading" @click="handleSubmit">
						{{$tt('提交上传')}}
					</Button>
					<Button @click="resetForm" style="margin-left:8px">{{$tt('重置')}}</Button>
				</FormItem>
			</Form>
		</Card>

		<Card :title="$tt('已上传固件列表')" class="table-card">
			<div class="table-tool-bar">
				<!-- <Button
					type="error"
					:disabled="selectedRows.length === 0"
					@click="handleDeleteFile"
				>
					{{$tt('批量删除选中(')}}{{selectedRows.length}}{{$tt(')')}}
				</Button> -->
				<Button @click="refreshFirmwireList" style="margin-left:8px">{{$tt('刷新固件列表')}}</Button>
			</div>
			<div class="table-wrap">
				<Table
					ref="firmwareTableRef"
					:columns="tableColumns"
					:data="firmwareTableData"
					border
					:loading="tableLoading"
					:height="tableHeight"
					size="small"
				>
					<MyPage slot="footer" ref="sonPageFile" :url="getUpgradeFilesUrl"
						:param="SelectParamFile" @listData="getFirmwareList" @tableLoading="tblLoading"></MyPage>
					<template slot-scope="{ row, index }" slot="action">
						<Dropdown style="margin-right: 5px" @on-click="(name) => menuClick(row, index, name)">
							<Button size="small" type="primary">
								{{$tt('操作')}}
								<Icon type="ios-arrow-down"></Icon>
							</Button>
							<DropdownMenu slot="list">
								<DropdownItem name="menuAssignOperators">{{$tt('分配客户')}}</DropdownItem>
								<DropdownItem name="menuAssignModels">{{$tt('编辑型号')}}</DropdownItem>
							</DropdownMenu>
						</Dropdown>
						<Button type="error" size="small" @click="handleDelete(row)">{{$tt('删除')}}</Button>
					</template>
				</Table>
			</div>
		</Card>
		<Modal v-model="showAssignOperators" :title="$tt('分配客户')" @on-ok="assignOperators" :mask-closable="false">
			<Form>
				<FormItem :label="$tt('适用客户')" prop="Operators">
					<Select
						v-model="assignForm.Operators"
						filterable
						multiple
						:placeholder="$tt('可多选适用客户')"
						style="width:100%"
					>
						<Option
							v-for="item in customerOptions"
							:key="item.Id"
							:label="item.Name"
							:value="item.Id"
						/>
					</Select>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="showAssignModels" :title="$tt('编辑适用型号')" @on-ok="assignModels" :mask-closable="false">
			<Form>
				<FormItem :label="$tt('适用设备型号')" prop="ModelIds">
					<Select
						v-model="assignForm.ModelIds"
						filterable
						multiple
						:placeholder="$tt('请选择适用设备型号（必填）')"
						style="width:100%"
					>
						<Option
							v-for="item in EquipmentModelDefine"
							:key="item.ModelId"
							:label="item.ModelDesc"
							:value="item.ModelId"
						/>
					</Select>
				</FormItem>
			</Form>
		</Modal>
	</div>
</template>

<script>
import webapi from '../../../webapi';
import {
	mapState
} from 'vuex'
export default {
	name: 'FirmwareUpload',
	data() {
		return {
			getUpgradeFilesUrl: webapi.base_api_url + '/System/GetUpgradeFiles',
			submitLoading: false,
			tableLoading: false,
			firmwareTableData: [],
			tableTotal: 0,
			pageNum: 1,
			pageSize: 15,
			selectedRows: [],
			SelectParamFile: {},
			tableHeight: "650",

			form: {
				FtpId: 0,
				FileVersion: '',
				FirmwareFile: null,
				FirmwireType: 0,
				Operators: [],
				ModelIds: [],
				Remark: null,
			},
			assignForm: {
				Operators: [],
				ModelIds: [],
			},
			curFtpInfo: null,
			showAssignOperators: false,
			showAssignModels: false,

			ftpOptions: [],
			formRules: {
				FtpId: [{ required: true, message: this.$tt('请选择FTP配置'), trigger: 'change', type: 'number' }],
				FileVersion: [{ required: true, message: this.$tt('请输入固件版本号'), trigger: 'blur' }],
				FirmwareFile: [{ required: true, message: this.$tt('请选择固件文件'), trigger: 'change' , type: 'object' }],
				
				FirmwireType: [{ required: true, message: this.$tt('请选择版本分类'), trigger: 'change', type: 'number' }],
				Operators: [
					{
						validator: (rule, value, callback) => {
							if (this.form.FirmwireType === 2) {
								if (!value || value.length < 1) return callback(new Error(this.$tt('请选择适用客户')));
							}
							callback()
						},
						trigger:'blur'
					},
					{
						validator: (rule, value, callback) => {
							if (this.form.FirmwireType === 2) {
								if (!value || value.length < 1) return callback(new Error(this.$tt('请选择适用客户')));
							}
							callback()
						},
						trigger:'change'
					},
				],
				ModelIds: [{ required: true, message: this.$tt('请选择适用设备型号'), trigger: 'change', type: 'array', min: 1 }]
			},

			tableColumns: [
				{ type: 'selection', width: 55 },
				{ title: this.$tt('固件文件名'), key: 'FileName', width: 220 },
				{ title: this.$tt('备注'), key: 'Remark', minWidth: 100, },
				{ title: this.$tt('版本分类'), key: 'FrimwareType', width: 110, render: (h, params) => { return h('div', params.row.FrimwareType == 1 ? '通用版本' : params.row.FrimwareType == 2 ? '定制版本' : '内部测试') }},
				{ title: this.$tt('固件版本'), key: 'FileVersion', width: 110 },
				{ title: this.$tt('FTP服务器'), key: 'FtpName', width: 110 },
				{ title: this.$tt('FTP地址'), key: 'FtpIp', width: 120 },
				{ title: this.$tt('适用客户'), key: 'OperatorsDesc', minWidth: 100, },
				{ title: this.$tt('适用设备型号'), key: 'EquipModelsDesc', minWidth: 100, },
				{ title: this.$tt('上传时间'), key: 'UploadTime', width: 160 },
				{
					title: this.$tt('操作'),
					key: 'action',
					slot: 'action',
					width: 150,
					// render: (h, params) => {
					// 	return h('div', [
					// 		h('Button', {
					// 			props: { type: 'primary', size: 'small' },
					// 			on: { click: () => this.handleAssignOperators(params.row) }
					// 		}, this.$tt('分配客户')),
					// 		h('Button', {
					// 			props: { type: 'primary', size: 'small' },
					// 			on: { click: () => this.handleAssignModels(params.row) }
					// 		}, this.$tt('编辑型号')),
					// 		h('Button', {
					// 			props: { type: 'error', size: 'small' },
					// 			on: { click: () => this.handleDelete(params.row) }
					// 		}, this.$tt('删除')),
					// 	]) 
					// }
				}
			]
		}
	},
	created() {
		const _this = this;
		_this.getTableHeight();
		window.addEventListener('resize', this.getTableHeight)
	},
	destroyed() {
		window.removeEventListener("resize", this.getTableHeight);
	},
	computed: {
		//直接选属性
		...mapState({
			StationList: 'Stations',
			customerOptions: 'typeList',
			EquipmentModelDefine: 'EquipmentModelDefine',
		})
	},
	mounted() {
		this.$refs.sonPageFile.getList()
		this.getFtpList()
	},
	methods: {
		getFtpList() {
			const _this = this
			_this.$axios.post(webapi.base_api_url + "/System/GetFtpParam", {}).then(res => {
				if (res.data.Code == 0) {
					this.ftpOptions = res.data.Data.List;
				}
			})
		},
		onSelectionChange(rows) {
			this.selectedRows = rows
		},
		// handleDeleteFile() {
		// 	const _this = this
		// 	if (!_this.selectedRows || _this.selectedRows.length == 0) {
		// 		_this.$Message.error(this.$tt('请点击文件列表选择要删除的文件'))
		// 		return;
		// 	} else {
		// 		let params = {
		// 			UpgradeFileId: _this.selectedRows.Id
		// 		}
		// 		_this.$axios.post(webapi.base_api_url + "/System/DeleteFileById", params).then(res => {
		// 			if (res.data.Code == 0) {
		// 				_this.refreshFirmwireList()
		// 				this.$Message.info(this.$tt('文件删除成功'));
		// 			}
		// 		})
		// 	}
		// 	_this.selectedRows = [];
		// 	_this.$refs.currentRowTable.clearCurrentRow();
		// },
		getFirmwareList(data) {
			this.firmwareTableData = data.Data.List
		},
		tblLoading(loading)
		{
			this.tableLoading = loading;
		},
		handlePageChange(page) {
			this.pageNum = page
			this.$refs.sonPageFile.getList()
		},
		handleAssignOperators(row) {
			this.assignForm.Id = row.Id;
			this.assignForm.Operators = JSON.parse(row.Operators);
			this.showAssignOperators = true;
		},
		handleAssignModels(row) {
			this.assignForm.Id = row.Id;
			this.assignForm.ModelIds = JSON.parse(row.EquipModels);
			this.showAssignModels = true;
		},
		handleDelete(row) {
			const _this = this;
			this.$Modal.confirm({
				title: this.$tt('提示'),
				content: `确定删除固件【${row.FileName}】？`,
				onOk: () => {
					let params = {
						UpgradeFileId: row.Id
					}
					_this.$axios.post(webapi.base_api_url + "/System/DeleteFileById", params).then(res => {
						if (res.data.Code == 0) {
							_this.refreshFirmwireList()
							this.$Message.success(this.$tt('文件删除成功'));
						}
					})
				}
			})
		},
		handleFtpChange(selectedId) {
			// 修正：用 == 兼容数字/字符串 id
			this.curFtpInfo = this.ftpOptions.find(item => item.Id == selectedId) || null;
			this.getTableHeight();
		},
		beforeUpload(file) {
			// 只允许 .bin / .sbin
			this.form.FirmwareFile = file;
			const allowSuffix = ['bin', 'sbin']
			const suffix = file.name.split('.').pop().toLowerCase()
			if (!allowSuffix.includes(suffix)) {
				this.$Message.warning(this.$tt('仅支持 .bin / .sbin 固件文件'))
				return false
			}
			return false
		},
		async handleSubmit() {
			const _this = this;
			try {
				await this.$refs.formRef.validate()
				//const innerFileList = this.$refs.uploadRef.getFile()
				if (!this.form.FirmwareFile) {
					this.$Message.warning(this.$tt('请选择固件文件'))
					return
				}
				this.submitLoading = true
				const fd = new FormData()
				//innerFileList.forEach(item => fd.append('firmwareFile', item.file))
				fd.append('FtpId', this.form.FtpId)
				fd.append('firmwareFile', this.form.FirmwareFile)
				fd.append('FirmwireType', this.form.FirmwireType);
				fd.append('FileVersion', this.form.FileVersion)
				fd.append('Operators', JSON.stringify(this.form.Operators))
				fd.append('ModelIds', JSON.stringify(this.form.ModelIds))
				if (this.form.Remark) {
					fd.append('Remark', this.form.Remark)
				}

				_this.$axios.post(webapi.base_api_url + '/System/UploadFirmwareFile', fd).then(res => {
					if (res.data.Code == 0) {
						this.$Message.success(this.$tt('固件上传成功'))
					}
				}).catch(() => {
						this.$Message.success(this.$tt('固件上传失败'))
				}).finally(() => {
					this.resetForm()
					this.$refs.sonPageFile.getList()
					this.form.FirmwareFile = null;
				})
			} catch (err) {
				if (err !== 'validate fail') this.$Message.error(this.$tt('提交失败'))
			} finally {
				this.submitLoading = false
			}
		},
		resetForm() {
			this.curFtpInfo = null
			this.$refs.formRef.resetFields()
			this.$refs.uploadRef.clearFiles()
		},
		refreshFirmwireList() {
			this.$refs.sonPageFile.getList("fileList");
		},
		getTableHeight: function() {
			this.tableHeight = window.innerHeight - 470;
			if (this.curFtpInfo) {
				this.tableHeight -= 52;
			}
		},
		assignOperators() {
			const _this = this;
			let params = {
				UpgradeFileId: this.assignForm.Id,
				Operators: this.assignForm.Operators
			};
			_this.$axios.post(webapi.base_api_url + '/System/AssignFirmwreOperators', params).then(res => {
				if (res.data.Code == 0) {
					this.$Message.success(this.$tt('分配客户成功'))
					this.refreshFirmwireList();
				}
			}).catch(() => {
				this.$Message.success(this.$tt('分配客户失败'))
			})
		},
		assignModels() {
			const _this = this;
			let params = {
				UpgradeFileId: this.assignForm.Id,
				ModelIds: this.assignForm.ModelIds,
			};
			_this.$axios.post(webapi.base_api_url + '/System/AssignFirmwreModels', params).then(res => {
				if (res.data.Code == 0) {
					this.$Message.success(this.$tt('分配型号成功'))
					this.refreshFirmwireList();
				}
			}).catch(() => {
				this.$Message.success(this.$tt('分配型号失败'))
			})
		},
		menuClick(row, index, name){
			// console.log(row, index, name)
			if(name === 'menuAssignOperators'){
				this.handleAssignOperators(row)
			}else if(name === 'menuAssignModels'){
				this.handleAssignModels(row)
			}
		},
	}
}
</script>

<style scoped>
.firmware-page {
	padding-bottom: 12px;
}

.upload-card {
	margin-bottom: 16px;
}
::v-deep .upload-card .ivu-card-body {
	padding: 12px 16px;
}

.compact-form ::v-deep .ivu-form-item {
	margin-bottom: 10px;
}
/* label 右对齐、不换行 */
.compact-form ::v-deep .ivu-form-item-label {
	text-align: right !important;
	white-space: nowrap !important;
}

/* FTP 详情独立展示区 */
.ftp-info-block {
	margin: -8px 0px 8px;
	padding: 10px 12px;
	background-color: #f7f8fa;
	border-radius: 6px;
}
.ftp-field {
	display: flex;
	align-items: center;
}
.ftp-label {
	flex: 0 0 52px;
	margin-right: 6px;
	color: #808695;
	font-size: 12px;
	white-space: nowrap;
	text-align: right;
}
.ftp-field .ivu-input {
	flex: 1;
}

.form-btn-row .ivu-form-item-content {
	text-align: left;
}

/* 表格正常大小，固定滚动高度，分页置底 */
.table-tool-bar {
	margin-bottom: 8px;
}
.table-wrap {
	overflow: hidden;
}
.page-wrap {
	margin-top: 8px;
	text-align: right;
}

::v-deep .ivu-select-placeholder {
	padding-right: 4px !important;
}
</style>
